import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNote1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="note-1"><path d="M3.75 3.75H20.25V16L16 20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 20.25V15.25H20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconNote1;
